<div [formGroup]="form" class="mobile-country-code test">
  <div [class.form-group]="useFormGroupClass">
    <div class="row grid-sm">
      <div class="cell" [style]="{ width: !equalSize ? '45%' : '50%' }">
        <label [for]="countryInputId" class="form-label label-no-overflow"
          >{{ 'USERS.FORMS.FIELD_LABELS.COUNTRY_CODE' | translate }}
          @if (isRequired(countryCodeKey)) {
            <span class="color-danger"
              >*
              <span class="sr-only">{{ 'COMMON.FORMS.FIELD_REQUIRED' | translate }}</span>
            </span>
          }
        </label>
        <div [class]="inputClass">
          <p-select
            [showClear]="false"
            [readonly]="readOnly"
            [tabindex]="tabindex ? +tabindex : null"
            [panelStyle]="{ position: dir === 'rtl' ? 'absolute' : 'auto', right: dir === 'rtl' ? '0' : 'auto' }"
            [placeholder]="'CLIENT.FORMS.FIELD_LABELS.COUNTRY_CODE' | translate"
            [formControlName]="countryCodeKey"
            filterBy="name_en,name_he,country_code"
            [options]="countries"
            [filter]="true"
            [inputId]="countryInputId"
            optionValue="country_code"
            optionLabel="country_code"
            >
            <ng-template let-country pTemplate="item">
              <span class="country-item row-inline">
                <img [alt]="country.name_en" [src]="country.icon" width="30" style="margin-inline-end: 20px" />
                <span class="country-name"
                  ><b>{{ country.country_code }}</b>
                  <div class="color-gray" style="width: 120px; text-overflow: ellipsis">
                    {{ country.name_en }}
                  </div>
                </span>
              </span>
            </ng-template>
            <ng-template let-country pTemplate="selectedItem">
              <span class="country-item row-inline">
                <img [alt]="country.name_en" [src]="country.icon" width="20" style="margin-inline-end: 10px" />
                <span class="country-name">{{ country.country_code }}</span>
              </span>
            </ng-template>
          </p-select>
        </div>
      </div>
      <div class="cell" [style]="{ width: !equalSize ? '55%' : '50%', order: '2' }">
        <label [for]="mobileInputId" class="form-label"
          >{{ 'USERS.FORMS.FIELD_LABELS.PHONE_NUMBER' | translate }}
          @if (isRequired(mobileKey)) {
            <span class="color-danger"
              >*
              <span class="sr-only">{{ 'COMMON.FORMS.FIELD_REQUIRED' | translate }}</span>
            </span>
          }
        </label>
        <div [class]="inputClass">
          <input
            [id]="mobileInputId"
            [formControlName]="mobileKey"
            [name]="mobileKey"
            [readonly]="readOnly"
            [placeholder]="'USERS.FORMS.FIELD_LABELS.PHONE_NUMBER' | translate"
            [attr.tabindex]="tabindex ? +tabindex + 1 : null"
            pKeyFilter="int"
            type="text"
            pInputText
            />
          </div>
        </div>
      </div>
    </div>
  </div>
